import * as type from '../action-types'
export default {
  state: {
    isAndroid: false,
    isiOS: false,
  },
  mutations: {
    [type.SET_IS_ANDROID](state, payload) {
      state.isAndroid = payload
    },
    [type.SET_IS_IOS](state, payload) {
      state.isiOS = payload
    },
  },
  actions: {},
  modules: {},
}
